import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { Documento, DynFormProps } from "../..";
import { Controller, useFormContext } from "react-hook-form";
import DisplayRetencao from "./DisplayRetencao";


export default function DynRetencao({
    spec,
    extras
}: DynRetencaoProps) {

    const { control, watch } = useFormContext();
    const addRetencao = watch(`${spec.name}.add_retencao`) === 'true'
    const isParcelado = extras?.is_parcelado === 'true'

    const valoresSelect = [
        { value: 'true', label: 'Sim', disabled: isParcelado },
        { value: 'false', label: 'Não', disabled: false }
    ]

    return (
        <Grid container spacing={2} mb={2}>
            <Grid size={{xs:12}}>
                <Controller
                    name={`${spec.name}.add_retencao`}
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <FormLabel id={`adicionar-retencao`}>
                                Deseja adicionar retenções a esse título?
                            </FormLabel>

                            <RadioGroup
                                {...field}
                                row
                                aria-labelledby="retencao-radio"
                            >
                                {
                                    valoresSelect.map((opcao, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={opcao.value}
                                            control={<Radio />}
                                            label={opcao.label}
                                            disabled={opcao.disabled}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            {
                addRetencao && (
                    <Grid size={{xs:12}}>
                        <DisplayRetencao spec_name={spec.name} />
                    </Grid>
                )
            }
        </Grid>
    )
}

interface DynRetencaoProps extends DynFormProps {
    extras: Documento | null
}
